import {
  SAVE_ACCOUNT,
  SAVE_ACCOUNT_PROFILE,
  SAVE_ACCOUNT_BRANDING,
  SAVE_ACCOUNT_SCHEDULE_SETTINGS,
  SAVE_ACCOUNT_REGIONAL_SETTINGS,
  SAVE_ACCOUNT_COMMUNICATION_SETTINGS,
  SAVE_ACCOUNT_REQUEST_SETTINGS,
  SAVE_ACCOUNT_QUOTE_SETTINGS,
  SAVE_ACCOUNT_JOB_SETTINGS,
  SAVE_ACCOUNT_JOB_TYPES,
  SAVE_ACCOUNT_JOB_STATUSES,
  SAVE_ACCOUNT_INVOICE_SETTINGS,
  SAVE_ACCOUNT_LICENSE_SETTINGS,
} from 'redux/constants/Account';

const theme = (state = {}, action) => {
  switch (action.type) {
  case SAVE_ACCOUNT:
    return {
      ...state,
      details: action.payload
    };
  case SAVE_ACCOUNT_PROFILE:
    return {
      ...state,
      profile: action.payload
    };
  case SAVE_ACCOUNT_BRANDING:
    return {
      ...state,
      branding: action.payload
    };
  case SAVE_ACCOUNT_SCHEDULE_SETTINGS:
    return {
      ...state,
      schedule_settings: action.payload
    };
  case SAVE_ACCOUNT_REGIONAL_SETTINGS:
    return {
      ...state,
      regional_settings: action.payload
    }; 
  case SAVE_ACCOUNT_COMMUNICATION_SETTINGS:
    return {
      ...state,
      communication_settings: action.payload
    };
  case SAVE_ACCOUNT_REQUEST_SETTINGS:
    return {
      ...state,
      request_settings: action.payload
    };
  case SAVE_ACCOUNT_QUOTE_SETTINGS:
    return {
      ...state,
      quote_settings: action.payload
    };
  case SAVE_ACCOUNT_JOB_SETTINGS:
    return {
      ...state,
      job_settings: action.payload
    };
  case SAVE_ACCOUNT_JOB_TYPES:
    return {
      ...state,
      job_types: action.payload
    };
  case SAVE_ACCOUNT_JOB_STATUSES:
    return {
      ...state,
      job_statuses: action.payload
    };
  case SAVE_ACCOUNT_INVOICE_SETTINGS:
    return {
      ...state,
      invoice_settings: action.payload
    };
  case SAVE_ACCOUNT_LICENSE_SETTINGS:
    return {
      ...state,
      license_settings: action.payload
    };
  default:
    return state;
  }
};

export default theme